// extracted by mini-css-extract-plugin
export var active = "_k5-2";
export var recordingDot = "_k5-1";
export var recordingIndicator = "_k5-0";